export const getCurrentLocation = (pathname: string): string =>
  `${process.env.RAZZLE_HOST}${pathname}`;
